import $ from "jquery";
import uly from "ulysses/core";
import ko from "knockout";
import HalResource from "ulysses/api";

import {compose_message, compose_sms} from "./communications/compose";
import {compose_document, edit_document, send_document_by_email} from "./communications/document";
import {preview_template, preview_templated_document} from "./communications/preview";
import { templated_reply_message, reply_message, templated_reply_all_message, reply_all_message, forward_message} from "./communications/reply";

function read_message(bound_entity) {
    HalResource(bound_entity).then(function (entity) {
        var res = null;
        if (entity && entity.related_id_s) {
            var entity = entity.related_id_s.split("#");
            res = uly.api.start().follow_with_cache("uly:data").follow("find", {
                "rel": entity[0] + "/" + entity[1]
            });
            //res = HalResource(uly.api.fetch_entity(entity.related_id_s));
        } else {
            res = HalResource(entity);
        }
        return res.follow("uly:readmessage").then(function (result) {
            result.message_data.title = result.message_data.subject;
            uly.dialogs.execute(result.dialog_markup, {
                buttons: [{
                    "button": "cancel",
                    "caption": _("communications_caption_back", "Back"),
                    "button_class": "btn",
                    "icon": "fa fa-times-circle",
                    "action": "closedialog"
                }]
            }, result.message_data);
        });
    });
};

uly.actions.saveaspdf = function (ev, $elt, ui) {
    var bound_entity = uly.utils.get_bound_entity($elt);
    // console.log("preview", bound_entity, ev, $elt, ui);
    saveaspdf(bound_entity);
};


uly.actions.previewdocument = function (ev, $elt, ui) {
    var bound_entity = uly.utils.get_bound_entity($elt);
    var title = bound_entity && ko.unwrap(bound_entity.title);
    if (!bound_entity && ui && ui.context && ui.context.$parent) {
        if (ui.context.$parent.dialog_data) {
            bound_entity = ui.context.$parent.dialog_data.document;
            title = ko.unwrap(ui.context.$parent.dialog_data.title);
        }
        else if (ui.context.$parent.id) {
            bound_entity = {
                "id": ui.context.$parent.id
            };
            title = ko.unwrap(ui.context.$parent.title);
        }
    } else {
        bound_entity = {
            "id": bound_entity.id
        };
    }
    preview_templated_document(bound_entity, title);
};

function wrap_handler(funk) {
    return (ev, $elt, ui, entity) => {
        var bound_entity = entity || uly.utils.get_bound_entity($elt);
        funk(bound_entity);
    };
}

Object.assign(uly.actions, {
    "composedocument": wrap_handler(compose_document),
    "composesms": wrap_handler(compose_sms),
    "editdocument": wrap_handler(edit_document),
    "composemessage": wrap_handler(compose_message),
    "readmessage": wrap_handler(read_message),
    "replymessage": wrap_handler(reply_message),
    "replytemplatedmessage": wrap_handler(templated_reply_message),
    "forwardmessage": wrap_handler(forward_message),
    "sendemail": wrap_handler(send_document_by_email),
    "replyallmessage": wrap_handler(reply_all_message),
    "replyalltemplatedmessage": wrap_handler(templated_reply_all_message),
});

uly.actions.editnotification = function (ev, $elt, ui, entity) {
    var data = ui;
    var resource = uly.utils.get_bound_resource($elt);
    var notification_name = ui.model.name();
    HalResource(resource).follow("find", {
        "rel": ui.model.name()
    }).then(function (notification) {
        var val = uly.actions.get_$elt_and_ui(ev, ui, "editnotification");
        //we've got the template
        ui = val[1];
        ui.entity_model = notification;
        ui.entity_model.id = notification_name;
        ui.entity_model.unique_id = "NotificationTemplate/" + notification_name;
        return uly.actions.standard_action(ev, val[0], ui);
    });
}

uly.actions.editfragment = function(ev, $elt, ui, entity) {
    var markup = ko.unwrap(ui.model.markup) || "";
    var entity = ui.context.$parent.entity;
    if (typeof entity !== "undefined") {
        entity = ko.unwrap(entity);
    } else {
        try {
            entity = ko.unwrap(ui.context.$parents[2].entity);
        } 
        catch(e) {
            entity = null;
        }
    }
    
    var rich_text = $elt.data("richText") || false;
    var dlg = "dlg_edit_fragment";
    if (!rich_text) {
        dlg = "dlg_edit_fragment_text";
    }
    uly.dialogs.show(dlg, {
        "no_process": true,
        "title": _("templated_docuemnt_edit_zone_title", "Edit Template Zone")
    }, 
    {
        "entity": entity,
        "markup": ko.observable(markup),
        "zone": ko.unwrap(ui.model.name),
        "channel": ko.unwrap(ui.context.$parent.channel.key_code),
        "template": ko.unwrap(ui.context.$parents[2].id)
    }
    ).then(function([result]) {
        ui.model.markup(ko.unwrap(result.markup));
    });
}

uly.actions.editdocfragment = function(ev, $elt, ui, entity) {
    var markup = ko.unwrap(ui.model.markup) || "";
    var rich_text = $elt.data("richText") || false;
    var dlg = "dlg_edit_document_fragment";
    if (!rich_text) {
        dlg = "dlg_edit_document_fragment_text";
    }
    uly.dialogs.show(dlg, {
        "no_process": true,
        "title": _("templated_document_edit_document_zone_title", "Edit Document Zone")
    }, 
    {
        "markup": ko.observable(markup),
        "zone": ko.unwrap(ui.model.name)
    }
    ).then(function([result]) {
        ui.model.markup(ko.unwrap(result.markup));
    });
}

uly.actions.refreshzones = function(newvalue, elt, ui) {
    var current_zones = ui.zones;
    if (newvalue) {
        uly.api.start()
               .follow("uly:data")
               .follow("uly:templatelayout", { "nodata": 1})
               .follow("find", {
                    "rel": newvalue,
                    "fields": "zones"
               }).then(function(result) {
            var zones = result.zones || [];
            var old_zones = ko.toJS(ui.zones);
            var markups = $(elt).data("markups") || {};
            old_zones.forEach((z) => { markups[z["name"]] = z["markup"] });
            var new_zones = [];
            zones.forEach((z) => {
                new_zones.push({
                    "name": ko.observable(z["name"]), 
                    "markup": ko.observable(markups[z["name"]]) 
                });
            });
            $(elt).data("markups", markups);
            ui.zones(new_zones);

        })
    }
}

uly.actions.previewtemplate = function(newvalue, $elt, ui) {
    var entity = ko.unwrap(ui.context.$parent.entity);
    var currentChannel = ko.unwrap(ui.model.selectedItem);
    var template_data = ko.toJS(ui.context.$data);
    if (entity) {
        uly.dialogs.search_entity(entity).then(function(entity) {
            preview_template(currentChannel, entity.unique_id);

        })
    } else {

        preview_template(currentChannel);
    }
}

uly.actions.previewchanneltemplate = function(newvalue, $elt, ui) {
    var entity = ko.unwrap(ui.context.$parent.entity);
    var currentChannel = ko.unwrap(ui.model.selectedItem);
    var template_data = ko.toJS(ui.context.$data);
    uly.dialogs.search_entity("lead").then(function(entity) {
            preview_template({
                channel: currentChannel.channel,
                zones: [{ "name": "content", "markup": currentChannel.template_body }]
            }, entity.unique_id);
    });
}

uly.actions.previewnotification = function(newvalue, $elt, ui) {
    var notification = ko.toJS(ui.context.$parent.dialog_data);
    var entity = notification.entity;
    var data = $.extend({
            "channel": { key_code: "email" },
    }, notification);
    if (entity) {
        uly.dialogs.search_entity(entity).then(function(entity) {
                preview_template(data, entity.unique_id);
        });
    } else {
        preview_template(data);
    }
}
